import { atom } from "recoil";

export const healthCheckFilterValueAtom = atom<string>({
	key: "healthCheckFilterValueAtom",
	default: "",
});
